import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getOperationProductsCompareLists,
  getOperationProductsCompareListsIsLoading,
  getProductsCompareListsState,
} from 'features/products-compare';
import { getCompareStatusMode, shouldShowCompareStatus, CompareStatusMode } from '../utils';
import { ValidationRules } from 'features/products-compare/ducks/reducers/validation-error';
import { COMPARE_PAGE_URL } from '../constants';

export const useCompareStatusState = (validationError: ValidationRules | null) => {
  const { operation, lastProductDelete } = useSelector(getOperationProductsCompareLists);
  const listsState = useSelector(getProductsCompareListsState);
  const isLoadingOperation = useSelector(getOperationProductsCompareListsIsLoading);
  const isError = !isLoadingOperation && listsState === 'error';
  const mode: CompareStatusMode = useMemo(
    () => getCompareStatusMode({ isError, operation, isAlert: !!validationError }),
    [isError, operation, validationError],
  );

  const shouldShow = useMemo(
    () =>
      mode === 'alert' || shouldShowCompareStatus(operation, lastProductDelete, isLoadingOperation, mode),
    [operation, lastProductDelete, isLoadingOperation, mode],
  );

  const redirectTo = mode === 'added' || mode === 'alert' ? COMPARE_PAGE_URL : undefined;

  return {
    operation,
    lastProductDelete,
    isLoadingOperation,
    isError,
    mode,
    shouldShow,
    redirectTo,
  };
};
